<template>
  <div>
    <section :class="[isShowPriview ? 'topPartBox' : '']">
      <avue-crud
        :option="thisFileOption"
        :data="fileData"
        ref="crud"
        :table-loading="loading"
      >
        <template slot="tip">
          <div class="d-f align-c">
            <el-button
              type="text"
              size="small"
              :loading="downloading"
              :disabled="!batchDownLight"
              @click.stop="batchDown(type, orderId)"
            >
              批量下载
            </el-button>
            <section v-if="!batchDownLight">
              <span class="c-red m-l-10">{{ zipName }}</span>
              <span class="m-lr-10">{{ process }}</span>
              <el-button
                type="text"
                size="small"
                :disabled="process != '100%'"
                @click="downloadZip"
              >
                下载
              </el-button>
              <el-button
                type="text"
                size="small"
                :disabled="process != '100%'"
                @click="deleteZip"
              >
                删除
              </el-button>
            </section>
          </div>
        </template>
        <template slot-scope="scope" slot="status">
          <span>{{ getStatus(scope.row.status) }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="menu">
          <el-button
            type="success"
            icon="el-icon-document"
            size="mini"
            plain
            @click.stop="rowView(previewUrl + row.fileUrl)"
          >
            预览
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="mini"
            plain
            @click.stop="rowDown(row, index)"
          >
            下载
          </el-button>
        </template>
      </avue-crud>
    </section>
    <!-- 预览 -->
    <div v-show="isShowPriview && actStatus" class="priviewBox">
      <div class="titleBox d-f justify-b align-c">
        <span class="c-333 f-w-600">稿件预览显示</span>
        <div>
          <el-button
            class="m-l-10"
            type="primary"
            size="mini"
            @click="closePreview"
          >
            关闭
          </el-button>
        </div>
      </div>
      <iframe
        class="w-block h-260 b-n"
        name="iframeDom"
        id="iframeDom"
        :src="iframeUrl"
      ></iframe>
    </div>
  </div>
</template>

<script>
import {
  listFile,
  newListFile,
  batchDownloadCheck,
  execute,
  zipUrl,
  zipProcess,
  zipDelete,
  zipName,
} from '@/api/dot/file';
import { statistics } from '@/api/dot/flow';

export default {
  props: [
    'fileOption',
    'type',
    'orderId',
    'tranFromat',
    'staParams',
    'taskType',
    'actStatus',
  ],
  data() {
    return {
      loading: false,
      downloading: false,
      fileData: [],
      thisFileOption: {
        ...this.fileOption,
        titleSize: 'h4',
        header: false, //表格头部中间菜单
        card: true,
        selection: true,
        refreshBtn: false,
        addBtn: false, //新增按钮
        columnBtn: false,
        editBtn: false,
        delBtn: false,
        reserveSelection: true,
        selectClearBtn: false,
        column: [
          {
            label: '稿件名称',
            prop: 'fileName',
            search: false,
          },
        ],
      },
      batchDownLight: null,
      process: '0%',
      timer: null,
      zipName: null,
      isShowPriview: false, //预览窗口
      iframeUrl: '',
    };
  },
  watch: {
    orderId: function (n, o) {
      if (n) {
        this.init();
      }
    },
    tranFromat(n, o) {
      if (n) {
        this.init();
        this.getZipName();
        this.$refs.crud.toggleSelection();
      }
    },
  },
  mounted() {
    this.init();
    this.getZipName();
  },
  methods: {
    // 获取zipName
    getZipName() {
      zipName({
        orderId: this.orderId,
        type: this.type,
        orderFlow: this.taskType,
        tranFormat: this.tranFromat,
      }).then((res) => {
        this.zipName = res.data.data.zipName;
        this.getBatchDownStatus(res.data.data.zipName);
      });
    },

    // 获取批量下载点亮状态
    getBatchDownStatus(name) {
      batchDownloadCheck({
        orderId: this.orderId,
        zipName: name,
      }).then((res) => {
        this.batchDownLight = res.data.data.light;
        if (!res.data.data.light) {
          this.process = res.data.data.process;
        } else {
          this.process = '0%';
        }
      });
    },

    // 获取下载进度
    getProcess() {
      zipProcess({
        orderId: this.orderId,
        zipName: this.zipName,
      }).then((res) => {
        this.process = res.data.data.process;
        if (res.data.data.process == '100%') {
          clearInterval(this.timer);
          this.timer = null;
        }
      });
    },

    // 下载zip包
    downloadZip() {
      zipUrl({
        orderId: this.orderId,
        zipName: this.zipName,
      }).then((res) => {
        let re = /#|%|&|amp;/gi;
        window.location.href = this.$stringFormat(this.downUrl, [
          res.data.data.zipUrl,
          this.zipName.replace(re, ''),
        ]);
        statistics(
          Object.assign(
            {
              event_name: '下载zip包',
              event_type: 'click',
            },
            this.staParams,
          ),
        );
      });
    },

    //删除zip包
    deleteZip() {
      zipDelete({
        orderId: this.orderId,
        zipName: this.zipName,
      }).then((res) => {
        this.batchDownLight = true;
        this.process = '0%';
      });
    },

    // getStatus
    getStatus(status) {
      let str = '';
      switch (status) {
        case -3:
          str = '取消';
          break;
        case -2:
          str = '取消';
          break;
        case -1:
          str = '失败';
          break;
        case 1:
          str = '待处理';
          break;
        case 2:
          str = '进行中';
          break;
        case 3:
          str = '进行中';
          break;
        case 4:
          str = '进行中';
          break;
        case 5:
          str = '进行中';
          break;
        case 6:
          str = '已完成';
          break;
      }
      return str;
    },

    init() {
      this.loading = true;
      if (this.tranFromat) {
        newListFile({
          orderId: this.orderId,
          fileType: this.type,
          tranFromat: this.tranFromat,
          isKit: this.$route.query.isKit,
        })
          .then((response) => {
            this.fileData = response.data.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        listFile({
          orderId: this.orderId,
          fileType: this.type,
          isKit: this.$route.query.isKit,
        })
          .then((response) => {
            this.fileData = response.data.data;
            let finish = this.fileData.filter((it) => it.status === 6).length;
            this.loading = false;
            let obj = { count: this.fileData.length, finish: finish };
            this.$emit('head', obj);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    // 预览
    rowView(fileUrl) {
      this.$emit('getPreStatus', false);
      // window.open(fileUrl);
      this.actStatus = true;
      this.iframeUrl = fileUrl;
      this.isShowPriview = true;
      statistics(
        Object.assign(
          {
            event_type: 'click',
            event_name: '预览',
          },
          this.staParams,
        ),
      );
    },

    // 关闭预览
    closePreview() {
      this.isShowPriview = false;
    },

    rowDown(row, index) {
      let re = /#|%|&|amp;/gi;
      window.location.href = this.$stringFormat(this.downUrl, [
        row.fileUrl,
        row.fileName.replace(re, ''),
      ]);
      statistics(
        Object.assign(
          {
            event_name: '下载',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    // 批量下载
    batchDown(type, orderId) {
      if (this.$refs.crud.tableSelect.length > 0) {
        let fileArray = [];
        this.$refs.crud.tableSelect.forEach((ele) => {
          fileArray.push({ fileUrl: ele.fileUrl, fileName: ele.fileName });
        });
        execute({
          orderId: this.orderId,
          zipName: this.zipName,
          files: fileArray,
        }).then((res) => {
          this.batchDownLight = false;
          this.timer = setInterval(this.getProcess, 5000);
        });
        /* this.downloading = true
        let tempForm = document.createElement('form')
        tempForm.action = '/dotadmin/dotadmin/file/downloadFile/' + type + '/' + orderId
        tempForm.method = 'post'
        tempForm.style.display = 'none'
        let fileArray = []
        this.$refs.crud.tableSelect.forEach(ele => {
          fileArray.push({fileUrl: ele.fileUrl, fileName: ele.fileName})
        })
        var opt = document.createElement('input')
        opt.name = "jsonStr"
        opt.value = JSON.stringify(fileArray)
        tempForm.appendChild(opt)
        document.body.appendChild(tempForm)
        tempForm.submit();
        setTimeout(() => {
          this.downloading = false
        }, 5000) */
        statistics(
          Object.assign(
            {
              event_name: '批量下载',
              event_type: 'click',
              class_name: 'downloadFile',
              class_url: '/dotadmin/dotadmin/file/downloadFile/',
              event_params: '{type: type, id: orderId}',
            },
            this.staParams,
          ),
        );
      } else {
        this.$message.error('请勾选稿件!');
      }
    },
  },
};
</script>

<style lang="scss">
.topPartBox {
  padding-bottom: 300px;
}
.priviewBox {
  width: 100%;
  height: 300px;
  border-top: 2px solid #eee;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2200;
  box-sizing: border-box;
  font-size: 14px;
  color: #666;
  .titleBox {
    background: #fff;
    padding: 0 20px 0 30px;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #eee;
  }
}
</style>
